import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MQService, MQSubject, MQMessage } from '../services/mq.service';

declare type EventCallback = (msg: MQMessage) => void;

export class MQComponent implements OnDestroy {
  private mqSubscribtions: Subscription[];
  private mqSubjects: MQSubject<MQMessage>[];
  constructor(protected mq: MQService) {
    this.mqSubscribtions = [];
    this.mqSubjects = [];
  }

  protected listenOn(eventName: string, callback: EventCallback) {
    const subject = this.mq.listenOn(eventName);
    this.mqSubjects.push(subject);
    this.mqSubscribtions.push(subject.asObservable().subscribe(callback));
  }

  ngOnDestroy() {
    for (const subs of this.mqSubscribtions) {
      subs.unsubscribe();
    }
    for (const subject of this.mqSubjects) {
      subject.unsubscribe();
    }
    this.mqSubscribtions = [];
    this.mqSubjects = [];
  }
}
